// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.game-settings .title {
  margin-top: 2.667rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--color-primary-blue);
  text-align: center;
}
.game-settings .button {
  background: var(--color-white);
  color: var(--color-primary-blue);
  border-radius: 32px;
  font-size: 1.167rem;
  font-weight: 600;
  text-align: center;
  max-width: 27.333rem;
  padding-top: 0.583rem;
  padding-bottom: 0.5rem;
  cursor: pointer;
  margin-top: 1.667rem;
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
}
.game-settings .button.first {
  margin-top: 2.117rem;
}
.game-settings .button .link-text {
  text-decoration: none;
  color: var(--color-primary-blue);
}
.game-settings .language-container {
  display: flex;
  justify-content: center;
  padding-top: 0.64rem;
  padding-bottom: 0;
}
.game-settings .language-container.first {
  padding-top: 1.625rem;
}
.game-settings .language-container .language {
  border-radius: 32px;
  border: 1px solid var(--color-primary-blue);
  background: rgba(255, 255, 255, 0.2);
  width: 11rem;
  text-align: center;
  color: var(--color-primary-blue);
  font-size: 1.167rem;
  font-weight: 600;
  padding-top: 0.583rem;
  padding-bottom: 0.5rem;
  cursor: pointer;
}
.game-settings .language-container .language.active {
  background: var(--color-white);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border: 0;
}
.game-settings .language-container .language:not(:last-child) {
  margin-right: 2rem;
}
.game-settings .audio-settings-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-primary-blue);
  padding-top: 2.5rem;
  padding-bottom: 0.708rem;
}
.game-settings .audio-settings-title.music {
  padding-top: 3.208rem;
}
.game-settings .audio-settings-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.game-settings .audio-settings-container .audio-settings-container img {
  width: 2.667rem;
  height: auto;
  cursor: pointer;
}
.game-settings .audio-settings-container .audio-settings-container img:first-child {
  margin-right: 0.667rem;
}
.game-settings .audio-settings-container .audio-settings-container img:last-child {
  margin-left: 0.667rem;
}
.game-settings .audio-settings-container .audio-settings-container img.disabled {
  cursor: default;
}
.game-settings .audio-settings-container .btn-container {
  position: relative;
}
.game-settings .audio-settings-container .btn-container .btn-icon {
  font-size: 1.333rem;
  position: absolute;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.game-settings .audio-settings-container .btn-container .plus {
  top: 0.675rem;
  left: 0.675rem;
}
.game-settings .audio-settings-container .btn-container ion-img::part(image) {
  width: 2.667rem;
  height: 2.667rem;
  cursor: pointer;
}
.game-settings .audio-settings-container .btn-container.left {
  margin-right: 0.667rem;
}
.game-settings .audio-settings-container .btn-container.right {
  margin-left: 0.667rem;
}
.game-settings .audio-settings-container .btn-container.disabled .btn-icon, .game-settings .audio-settings-container .btn-container.disabled ion-img::part(image) {
  cursor: default;
}
.game-settings .audio-settings-container .progress-bar {
  height: 1rem;
  border-radius: 0.5rem;
  --background: var(--color-light-blue);
  --progress-background: var(--color-primary-blue);
}
.game-settings .audio-settings-container .progress-bar::part(stream) {
  display: none;
}
.game-settings .audio-settings-container .button {
  border: 1px solid var(--color-primary-blue);
  background: rgba(255, 255, 255, 0.2);
  color: var(--color-primary-blue);
  padding: 0.583rem 3.563rem 0.5rem 3.563rem;
  margin-top: 0;
}
.game-settings .audio-settings-container .button:hover, .game-settings .audio-settings-container .button.disabled {
  background: var(--color-white);
  border-color: var(--color-white);
}

.version {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  color: var(--color-primary-blue);
  font-size: 1rem;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/game/game-settings/game-settings.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAGE;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,yCAAA;AADJ;AAGI;EACE,oBAAA;AADN;AAII;EACE,qBAAA;EACA,gCAAA;AAFN;AAME;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AAJJ;AAMI;EACE,qBAAA;AAJN;AAOI;EACE,mBAAA;EACA,2CAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AALN;AAOM;EACE,8BAAA;EACA,yCAAA;EACA,SAAA;AALR;AAQM;EACE,kBAAA;AANR;AAWE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,wBAAA;AATJ;AAWI;EACE,qBAAA;AATN;AAaE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAXJ;AAaI;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAXN;AAYM;EACE,sBAAA;AAVR;AAYM;EACE,qBAAA;AAVR;AAYM;EACE,eAAA;AAVR;AAeI;EACE,kBAAA;AAbN;AAeM;EACE,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAbR;AAgBM;EACE,aAAA;EACA,cAAA;AAdR;AAiBM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAfR;AAkBM;EACE,sBAAA;AAhBR;AAkBM;EACE,qBAAA;AAhBR;AAmBQ;EACE,eAAA;AAjBV;AAsBI;EACE,YAAA;EACA,qBAAA;EACA,qCAAA;EACA,gDAAA;AApBN;AAsBM;EACE,aAAA;AApBR;AAwBI;EACE,2CAAA;EACA,oCAAA;EACA,gCAAA;EACA,0CAAA;EACA,aAAA;AAtBN;AAwBM;EACE,8BAAA;EACA,gCAAA;AAtBR;;AA4BA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AAzBF","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.game-settings {\n  .title {\n    margin-top: 2.667rem;\n    font-size: 1rem;\n    font-weight: bold;\n    color: var(--color-primary-blue);\n    text-align: center;\n  }\n\n  .button {\n    background: var(--color-white);\n    color: var(--color-primary-blue);\n    border-radius: 32px;\n    font-size: 1.167rem;\n    font-weight: 600;\n    text-align: center;\n    max-width: 27.333rem;\n    padding-top: 0.583rem;\n    padding-bottom: 0.5rem;\n    cursor: pointer;\n    margin-top: 1.667rem;\n    box-shadow: 0 4px 0 0 rgba(0,0,0,0.16);\n\n    &.first {\n      margin-top: 2.117rem;\n    }\n\n    .link-text {\n      text-decoration: none;\n      color: var(--color-primary-blue);\n    }\n  }\n\n  .language-container {\n    display: flex;\n    justify-content: center;\n    padding-top: 0.64rem;\n    padding-bottom: 0;\n\n    &.first {\n      padding-top: 1.625rem;\n    }\n  \n    .language {\n      border-radius: 32px;\n      border: 1px solid var(--color-primary-blue);\n      background: rgba(255, 255, 255, 0.2);\n      width: 11rem;\n      text-align: center;\n      color: var(--color-primary-blue);\n      font-size: 1.167rem;\n      font-weight: 600;\n      padding-top: 0.583rem;\n      padding-bottom: 0.5rem;\n      cursor: pointer;\n\n      &.active {\n        background: var(--color-white);\n        box-shadow: 0 4px 0 0 rgba(0,0,0,0.16);\n        border: 0;\n      }\n\n      &:not(:last-child) {\n        margin-right: 2rem;\n      }\n    }\n  }\n\n  .audio-settings-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--color-primary-blue);\n    padding-top: 2.5rem;\n    padding-bottom: 0.708rem;\n\n    &.music {\n      padding-top: 3.208rem;\n    }\n  }\n\n  .audio-settings-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .audio-settings-container img {\n      width: 2.667rem;\n      height: auto;\n      cursor: pointer;\n      &:first-child {\n        margin-right: 0.667rem;\n      }\n      &:last-child {\n        margin-left: 0.667rem;\n      }\n      &.disabled {\n        cursor: default;\n      }\n    }\n\n\n    .btn-container {\n      position: relative;\n\n      .btn-icon {\n        font-size: 1.333rem;\n        position: absolute;\n        color: var(--color-primary-blue);\n        cursor: pointer;\n      }\n  \n      .plus {\n        top: 0.675rem;\n        left: 0.675rem;\n      }\n\n      ion-img::part(image) {\n        width: 2.667rem;\n        height: 2.667rem;\n        cursor: pointer;\n      }\n\n      &.left {\n        margin-right: 0.667rem;\n      }\n      &.right {\n        margin-left: 0.667rem;\n      }\n      &.disabled {\n        .btn-icon, ion-img::part(image) {\n          cursor: default;\n        }\n      }\n    }\n\n    .progress-bar {\n      height: 1rem;\n      border-radius: 0.5rem;\n      --background: var(--color-light-blue);\n      --progress-background: var(--color-primary-blue);\n\n      &::part(stream) {\n        display: none;\n      }\n    }\n\n    .button {\n      border: 1px solid var(--color-primary-blue);\n      background: rgba(255, 255, 255, 0.2);\n      color: var(--color-primary-blue);\n      padding: 0.583rem 3.563rem 0.5rem 3.563rem;\n      margin-top: 0;\n\n      &:hover, &.disabled {\n        background: var(--color-white);\n        border-color: var(--color-white);\n      }\n    }\n  }\n}\n\n.version {\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  color: var(--color-primary-blue);\n  font-size: 1rem;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
